import { apiSlice } from "../apiSlice";

const parcelApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPickupParcelList: builder.query({
            query: (id) => {
                return {
                    url: `/api/branch/pickup-parcel-list/${id}`,
                    method: 'GET',
                }
            },
            providesTags: ['pacelList']
        }),
        getDeliveryParcelList: builder.query({
            query: (id) => {
                return {
                    url: `/api/branch/delivery-parcel-list/${id}`,
                    method: 'GET',
                }
            },
            providesTags: ['pacelList']
        }),
        assignPickupRider: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/branch/assign/pickup`,
                    method: 'POST',
                    body,
                }
            },
            invalidatesTags: ['pacelList']
        }),
        assignDeliveryRider: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/branch/assign/delivery`,
                    method: 'POST',
                    body,
                }
            },
            invalidatesTags: ['pacelList']
        }),
        assignReturnRider: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/branch/assign/return`,
                    method: 'POST',
                    body,
                }
            },
            invalidatesTags: ['pacelList']
        }),
        createParcel: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/parcel/create`,
                    method: 'POST',
                    body
                }
            },
            invalidatesTags: ['pacelList']
        }),
        updateParcel: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/parcel/update/${body?.id}`,
                    method: 'PATCH',
                    body: body?.data
                }
            },
            invalidatesTags: ['pacelList']
        }),
        findParcelByOrderID: builder.query({
            query: (orderId) => {
                return {
                    url: `/api/parcel/${orderId}`,
                    method: 'GET',
                }
            },
        }),
    }),
    overrideExisting: true,
});

export const { useGetPickupParcelListQuery, useGetDeliveryParcelListQuery, useCreateParcelMutation, useUpdateParcelMutation, useFindParcelByOrderIDQuery, useAssignPickupRiderMutation, useAssignDeliveryRiderMutation, useAssignReturnRiderMutation } = parcelApiSlice;
